import { createLocaleProvider as e, defaultNS as t, isLocalizedCountriesRegistered as n, registerLocalizedCountries as r } from "@systemeio/util";
import { jsx as i } from "react/jsx-runtime";
//#region src/i18n/context.tsx
var { LocaleContext: a, LocaleProvider: o } = e(), s = (e) => {
	let a = e.i18n?.getResource(e.languageCode, t, "countries");
	return a && !n(e.languageCode) && r({
		locale: e.languageCode,
		countries: a
	}), /* @__PURE__ */ i(o, { ...e });
};
//#endregion
export { a as LocaleContext, s as LocaleProvider };
